import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { RevisionsSchema, RevisionsSchemaUpdate } from './revisions.schema';

const { FLOW } = PERMISSIONS;

export const revisionsContract = createRESTContract({
  createRevision: {
    method: 'POST',
    path: '/revision',
    permissions: [FLOW.FLOW_REVISION_UPDATE],
    response: RevisionsSchema,
    body: RevisionsSchemaUpdate,
  },
  setRevisionAsActive: {
    method: 'PATCH',
    path: '/revisions/activate/:id',
    permissions: [FLOW.FLOW_REVISION_UPDATE],
    response: z.object({ success: z.boolean() }),
    body: z.undefined(),
  },
  getAllRevisions: {
    method: 'GET',
    path: '/revisions',
    permissions: [FLOW.FLOW_LIST],
    response: z.array(RevisionsSchema),
  },
  updateRevision: {
    method: 'PUT',
    path: '/revision/:id',
    permissions: [FLOW.FLOW_REVISION_UPDATE],
    response: z.object({ success: z.boolean() }),
    body: RevisionsSchemaUpdate,
  },
  deleteRevision: {
    method: 'DELETE',
    path: '/revision/:id',
    permissions: [FLOW.FLOW_REVISION_DELETE],
    response: z.object({ success: z.boolean() }),
    body: z.undefined(),
  },
});
